import { getServerBlockType } from "@pathwright/blocks-core"
import { capitalize, find } from "lodash"

const deprecatedLayouts = [
  {
    blockType: "Video",
    layout: "center"
  },
  {
    blockType: "Embed",
    layout: "center"
  },
  {
    blockType: "Image",
    layout: "center"
  }
]

export const getBlockTypeLabel = ({ type, blockTypes, layout }) => {
  const BT = getServerBlockType(type, blockTypes)
  const BL = BT.layouts
    ? Object.values(BT.layouts).find((bl) => bl.key === layout)
    : null
  return BL ? BL.label : capitalize(type)
}

export const getBlockTypeLayoutOptions = ({ type, blockTypes }) => {
  const BT = getServerBlockType(type, blockTypes)
  return Object.values(BT.layouts || []).filter(({ key }) =>
    filterDeprecatedLayouts({ type: BT.type, layout: key })
  )
}

const filterDeprecatedLayouts = ({ type, layout }) => {
  const found = find(
    deprecatedLayouts,
    (l) => l.blockType === type && l.layout === layout
  )
  return !found
}

export const filterDeprecatedMenuOption = ({ blockType, layout }) =>
  filterDeprecatedLayouts({ type: blockType, layout })

export const mapLayoutToMenuOption = (bt) => (layout) => ({
  blockType: bt.type,
  data: layout.data,
  layout: layout.key,
  label: layout.label,
  menuCategory: layout.menuCategory || bt.menu.category,
  menuOrder: layout.menuOrder || bt.menu.order,
  previewImage: layout.previewImage || ""
})

export const addMovedLayoutsToMenu = (blockTypes, menuData) => {
  const movedLayoutOptions = blockTypes.reduce((movedOptions, bt) => {
    const btLayouts = Object.values(bt.layouts || {})
    const btMoved = btLayouts.filter(({ menuCategory }) => !!menuCategory)
    const options = btMoved.map((layout) => mapLayoutToMenuOption(bt)(layout))

    // const menuCategory = menuData[]

    return movedOptions.concat(options)
  }, [])

  // console.log({ movedLayoutOptions, menuData })

  return menuData
}
